import React, { useState, useEffect, useCallback, useRef } from 'react';
import AgentControlPanel from './AgentControlPanel';

interface ClosingCTASectionProps {
  onOpenDemoModal: () => void;
}

const ClosingCTASection: React.FC<ClosingCTASectionProps> = ({ onOpenDemoModal }) => {
  return (
    <section className="relative py-8 sm:py-12 lg:py-8 px-4 sm:px-6 mb-4">
      <AgentControlPanel onOpenDemoModal={onOpenDemoModal} />
    </section>
  );
};

export default ClosingCTASection;